import 'fslightbox';

const lightboxGallery = () => {
    [...document.querySelectorAll('.wp-block-gallery, .masonry-gallery')].map((gallery, index) => {
        const images = gallery.querySelectorAll('a');
        if (images.length > 0) {
            const lightbox = new FsLightbox();
            const imagesArr = [...images];

            lightbox.props.sources = [];
            lightbox.props.types = [];

            // Zmienne zabezpieczające przed duchami w tle
            let autoplayTimeout;
            let isLightboxOpen = false;

            const updateCaption = () => {
                const { container } = lightbox.elements;
                if (!container) return;

                const currentIndex = lightbox.stageIndexes.current;
                const currentLink = imagesArr[currentIndex];
                const captionText = currentLink ? currentLink.getAttribute('data-fs-title') : '';
                const currentHref = currentLink ? currentLink.href : '';

                const nav = container.querySelector('.fslightbox-nav');
                if (nav) {
                    let counterContainer = nav.querySelector('.fslightboxsn');

                    if (!counterContainer) {
                        counterContainer = document.createElement('div');
                        counterContainer.className = 'fslightboxsn';
                        nav.appendChild(counterContainer);
                    }

                    let captionSpan = counterContainer.querySelector('.fs-title-custom');

                    if (!captionSpan) {
                        captionSpan = document.createElement('span');
                        captionSpan.className = 'fs-title-custom';
                        counterContainer.appendChild(captionSpan);
                    }

                    captionSpan.innerHTML = captionText ? ` ${captionText}` : '';
                }

                const allVideos = container.querySelectorAll('video');

                // Pauzujemy wszystko od razu
                allVideos.forEach(v => v.pause());

                // Czyścimy poprzednie odliczanie, żeby się nie nałożyły
                clearTimeout(autoplayTimeout);

                // Odpalamy nowe odliczanie z twardym warunkiem
                autoplayTimeout = setTimeout(() => {
                    // KILL SWITCH: Jeśli użytkownik zamknął galerię w ciągu tych 250ms - PRZERWIJ!
                    if (!isLightboxOpen) return;

                    allVideos.forEach(video => {
                        const videoSrc = video.src || (video.querySelector('source') ? video.querySelector('source').src : '');

                        if (currentHref && videoSrc && videoSrc.includes(currentHref)) {
                            video.muted = false;
                            video.defaultMuted = false;
                            video.setAttribute('playsinline', '');

                            const playPromise = video.play();

                            if (playPromise !== undefined) {
                                playPromise.catch(() => {
                                    video.muted = true;
                                    video.play();
                                });
                            }
                        } else {
                            video.pause();
                        }
                    });
                }, 250);
            };

            lightbox.props.onOpen = function () {
                isLightboxOpen = true; // Ustawiamy flagę, że jesteśmy w grze

                const { container } = lightbox.elements;
                container.role = 'alertdialog';
                container.ariaModal = 'true';

                setTimeout(() => {
                    container.tabIndex = 0;
                    container.focus();
                    updateCaption();
                }, 1);

                const btns = container.querySelectorAll('.fslightbox-toolbar-button, .fslightbox-slide-btn-container');
                [...btns].map((btn) => {
                    btn.role = 'button';
                    btn.tabIndex = 0;
                    btn.addEventListener('keyup', function (ev) {
                        const kc = ev.which || ev.keyCode;
                        if (kc !== 9 && kc !== 37 && kc !== 39 && kc !== 16) {
                            this.click();
                        }
                    });
                    btn.addEventListener('click', () => {
                        clearTimeout(autoplayTimeout); // Reset opóźnienia po kliknięciu
                        setTimeout(updateCaption, 100);
                    });
                });
            };

            lightbox.props.onShow = updateCaption;

            lightbox.props.onClose = function () {
                isLightboxOpen = false; // BLOKUJEMY możliwość odpalenia video z opóźnienia!
                clearTimeout(autoplayTimeout); // Ubijamy odliczanie

                if (window.galleryTrigger) {
                    window.galleryTrigger.focus();
                }

                const { container } = lightbox.elements;
                if (container) {
                    const activeVideos = container.querySelectorAll('video');
                    activeVideos.forEach(video => {
                        video.pause();
                        video.removeAttribute('src');
                        video.load();
                    });
                }
            };

            imagesArr.map((image, imageIndex) => {
                const url = image.href;
                lightbox.props.sources.push(url);

                const isVideo = url.match(/\.(mp4|webm|ogg|mov)($|\?)/i);
                lightbox.props.types.push(isVideo ? 'video' : 'image');

                image.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.galleryTrigger = image;
                    lightbox.open(imageIndex);
                });
            });
        }
    });
};

export default lightboxGallery;